import { useRef } from 'react';

const useElementById = (elementId = 'dynamic-modal') => {
    const modalRootElement = useRef(null);
    if (typeof window !== 'undefined') {
        modalRootElement.current = window.document.getElementById(elementId);
        // creates div and attaches it to the body
        if (!modalRootElement.current) {
            modalRootElement.current = window.document.createElement('div');
            modalRootElement.current.setAttribute('id', elementId);
            modalRootElement.current.setAttribute('class', elementId);
            modalRootElement.current.setAttribute('data-testid', elementId);
            window.document.body.appendChild(modalRootElement.current);
        }
    }
    return modalRootElement;
};

export { useElementById };
